module.exports = __webpack_public_path__ + "static/media/Hero-edit.f45ad62c.png";